//Complete Account
export {default as Guarantee} from './complete-account/guarantee'
export * from './social-media'
export {default as SplitTout} from './touts/splitTout/splitTout'
export {default as SubscriptionShipping} from './complete-account/subscriptionShipping'
export {default as Page} from './page'
//Forms
export {default as DefaultSection} from './forms/defaultSection'



// WEBPACK FOOTER //
// ./src/modules/index.js